'format es6';
'use strict';

const name = 'cursus';

import $ from 'jquery';
import gsap from 'greensock';
import Promise from 'Promise';
require('es6-map/implement');

try { require('source-map-'+'support').install(); } catch (e) { }

// The ns constant is created only once and is a window sub-object to 
// namespace public functions or properties throughout the app, without
// pollution the global scope.
const ns = window[name] = (window[name] || {});

/**
 * Gets the body element
 *
 * @return {jQuery} body
 */
ns.getBody = (() => {
	let body;
	return () => {
		body = body || $('body');
		return body;
	};
})();


/**
 *  Get a unique ID, prefixed with "uid"
 * 
 * @return {String}
 */
ns.getUniqueID = (() => {
	let id = 0;
	return () => `uid${id++}`;
})();

/**
 * Wrapper for the $(document).ready() function to be a then-able
 * object.
 * 
 * @Promise {Function}
 * 
 * @return {Promise}
 */
ns.docReady = (() => {
	return new Promise((resolve, reject) => {
		$(document).ready(resolve);
	});
})();

/**
 * Check if the viewport width is smaller or equal to a treshold
 *
 * @param {Number} treshold
 * 
 * @return {Boolean}
 */
ns.isMobile = (treshold = 992) => $(window).width() <= treshold;

/**
 * Scrolls to an element position using TweenMax. If an offset is 
 * defined, scrolls that amount higher than the target element.
 *
 * @param {jQuery Object | DOM Node} el
 * @param {Number} offset
 */
ns.scrollToElem = (el, offset = 0) => {
	const $el = $(el);
	const st = $(window).scrollTop();
	const scroll = {
		y: st,
	};

	gsap.TweenMax.to(scroll, 0.6, {
		y: $el.offset().top + offset,
		ease: gsap.Cubic.easeInOut,
		onUpdate: () => {
			$(window).scrollTop(scroll.y);
		},
	});
};

/**
 * Takes an array as a param, shuffles it and returns it. Does not
 * create a new array.
 *
 * @param {Array} array
 * 
 * @return {Array} array
 */
ns.shuffleArray = (array) => {
	for (let i = array.length - 1; i > 0; i--) {
		const j = Math.floor(Math.random() * (i + 1));
		const temp = array[i];
		array[i] = array[j];
		array[j] = temp;
	}
	return array;
};

// Map of slugs for each domain. Identifier follows this syntax : {domain_id}_{lang}
ns.domainSlugs = new Map([
	['1_fr', 'humain'],
	['1_en', 'humain'],
	['2_fr', 'gestion'],
	['2_en', 'management'],
	['3_fr', 'vivant'],
	['3_en', 'living'],
	['4_fr', 'matiere'],
	['4_en', 'matiere'],
	['5_fr', 'culture'],
	['5_en', 'culture'],
]);

// Map of letters for each domain. Identifier follows this syntax : {domain_id}_{lang}
ns.domainLetters = new Map([
	['1_fr', 'H'],
	['1_en', 'H'],
	['2_fr', 'G'],
	['2_en', 'M'],
	['3_fr', 'V'],
	['3_en', 'L'],
	['4_fr', 'M'],
	['4_en', 'M'],
	['5_fr', 'C'],
	['5_en', 'C'],
]);

// Default user name if the User is not logged in.
ns.defaultUserDisplayName = ns.lang === 'fr' ? 'Invité' : 'Guest';

export default ns;
